export default __webpack_public_path__ + "static/media/EXEMPLO 5.fc89a863.jpg";